export const books = [
  {
    id: 1,
    title: 'The Great Gatsby',
    author: 'F. Scott Fitzgerald',
    cover: '/assets/book-covers/great-gatsby.png',
    price: 12.99,
    rating: 4.5,
    description:
      "Set in the Jazz Age on Long Island, the novel depicts narrator Nick Carraway's interactions with mysterious millionaire Jay Gatsby and Gatsby's obsession to reunite with his former lover, Daisy Buchanan.",
    publisher: 'Scribner',
    year: 1925,
    isbn: '9780743273565',
    pages: 180,
    genre: 'Fiction',
    formats: [
      { type: 'Paperback', price: 12.99 },
      { type: 'Hardcover', price: 18.99 },
      { type: 'E-book', price: 7.99 },
    ],
    reviews: [
      { user: 'John D.', rating: 5, comment: 'A timeless classic that never gets old.' },
      { user: 'Sarah M.', rating: 4, comment: 'Beautifully written, captures the essence of the era.' },
    ],
  },
  {
    id: 2,
    title: 'To Kill a Mockingbird',
    author: 'Harper Lee',
    cover: '/assets/book-covers/to-kill-a-mockingbird.png',
    price: 14.99,
    rating: 4.8,
    description:
      'The unforgettable novel of a childhood in a sleepy Southern town and the crisis of conscience that rocked it.',
    publisher: 'HarperCollins',
    year: 1960,
    isbn: '9780061120084',
    pages: 336,
    genre: 'Fiction',
    formats: [
      { type: 'Paperback', price: 14.99 },
      { type: 'Hardcover', price: 22.99 },
      { type: 'E-book', price: 9.99 },
      { type: 'Audiobook', price: 24.99 },
    ],
    reviews: [
      { user: 'Michael R.', rating: 5, comment: 'One of the greatest novels of all time.' },
      { user: 'Emily W.', rating: 5, comment: 'Required reading for everyone.' },
    ],
  },
  {
    id: 3,
    title: '1984',
    author: 'George Orwell',
    cover: '/assets/book-covers/1984.png',
    price: 11.99,
    rating: 4.7,
    description: 'A dystopian novel set in a totalitarian society ruled by Big Brother.',
    publisher: 'Secker & Warburg',
    year: 1949,
    isbn: '9780451524935',
    pages: 328,
    genre: 'Science Fiction',
    formats: [
      { type: 'Paperback', price: 11.99 },
      { type: 'Hardcover', price: 17.99 },
      { type: 'E-book', price: 6.99 },
    ],
    reviews: [
      { user: 'David K.', rating: 5, comment: 'Prophetic and frightening.' },
      { user: 'Anna L.', rating: 5, comment: 'A warning for all times.' },
    ],
  },
  {
    id: 4,
    title: 'Pride and Prejudice',
    author: 'Jane Austen',
    cover: '/assets/book-covers/pride-and-prejudice.png',
    price: 9.99,
    rating: 4.6,
    description: 'The story follows Elizabeth Bennet as she deals with issues of manners, upbringing, and marriage.',
    publisher: 'T. Egerton, Whitehall',
    year: 1813,
    isbn: '9780141439518',
    pages: 432,
    genre: 'Romance',
    formats: [
      { type: 'Paperback', price: 9.99 },
      { type: 'Hardcover', price: 15.99 },
      { type: 'E-book', price: 5.99 },
    ],
    reviews: [
      { user: 'Catherine P.', rating: 5, comment: 'A perfect novel with unforgettable characters.' },
      { user: 'Thomas G.', rating: 4, comment: 'Witty and engaging throughout.' },
    ],
  },
  {
    id: 5,
    title: 'The Hobbit',
    author: 'J.R.R. Tolkien',
    cover: '/assets/book-covers/the-hobbit.png',
    price: 13.99,
    rating: 4.9,
    description: 'Bilbo Baggins goes on an unexpected journey in the midst of dragons, goblins, and magical rings.',
    publisher: 'Allen & Unwin',
    year: 1937,
    isbn: '9780547928227',
    pages: 366,
    genre: 'Fantasy',
    formats: [
      { type: 'Paperback', price: 13.99 },
      { type: 'Hardcover', price: 21.99 },
      { type: 'E-book', price: 8.99 },
    ],
    reviews: [
      { user: 'Peter J.', rating: 5, comment: 'The perfect introduction to Middle Earth.' },
      { user: 'Susan B.', rating: 5, comment: 'A magical adventure from start to finish.' },
    ],
  },
  {
    id: 6,
    title: 'Sapiens',
    author: 'Yuval Noah Harari',
    cover: '/assets/book-covers/history-of-humankind.png',
    price: 15.99,
    rating: 4.7,
    description: "A groundbreaking narrative of humanity's creation and evolution.",
    publisher: 'Harper',
    year: 2015,
    isbn: '9780062316097',
    pages: 464,
    genre: 'Non-Fiction',
    formats: [
      { type: 'Paperback', price: 15.99 },
      { type: 'Hardcover', price: 24.99 },
      { type: 'E-book', price: 12.99 },
    ],
    reviews: [
      { user: 'James H.', rating: 5, comment: 'Mind-blowing perspective on human history.' },
      { user: 'Lisa T.', rating: 4, comment: 'Thought-provoking and accessible.' },
    ],
  },
  {
    id: 7,
    title: 'Educated',
    author: 'Tara Westover',
    cover: '/assets/book-covers/educated.png',
    price: 14.49,
    rating: 4.8,
    description: 'An unforgettable memoir about a young girl who goes on to earn a PhD from Cambridge University.',
    publisher: 'Random House',
    year: 2018,
    isbn: '9780399590504',
    pages: 352,
    genre: 'Biography',
    formats: [
      { type: 'Paperback', price: 14.49 },
      { type: 'Hardcover', price: 22.99 },
      { type: 'E-book', price: 9.99 },
    ],
    reviews: [
      { user: 'Mark P.', rating: 5, comment: 'Powerful and inspiring journey.' },
      { user: 'Jennifer K.', rating: 4, comment: 'Beautifully written and moving.' },
    ],
  },
  {
    id: 8,
    title: 'Gone Girl',
    author: 'Gillian Flynn',
    cover: '/assets/book-covers/gone-girl.png',
    price: 12.99,
    rating: 4.2,
    description: "On their fifth wedding anniversary, Nick's clever and beautiful wife Amy disappears.",
    publisher: 'Crown Publishing Group',
    year: 2012,
    isbn: '9780307588371',
    pages: 432,
    genre: 'Thriller',
    formats: [
      { type: 'Paperback', price: 12.99 },
      { type: 'Hardcover', price: 19.99 },
      { type: 'E-book', price: 8.99 },
    ],
    reviews: [
      { user: 'Sarah J.', rating: 5, comment: 'Twisted and unpredictable.' },
      { user: 'Robert L.', rating: 3, comment: 'Interesting but disturbing characters.' },
    ],
  },
  // Mystery books
  {
    id: 9,
    title: 'The Girl with the Dragon Tattoo',
    author: 'Stieg Larsson',
    cover: '/assets/book-covers/dragon-tattoo.png',
    price: 13.99,
    rating: 4.3,
    description: 'A journalist and a hacker investigate the disappearance of a woman from a wealthy family.',
    publisher: 'Norstedts Förlag',
    year: 2005,
    isbn: '9780307454546',
    pages: 465,
    genre: 'Mystery',
    formats: [
      { type: 'Paperback', price: 13.99 },
      { type: 'Hardcover', price: 20.99 },
      { type: 'E-book', price: 9.99 },
    ],
    reviews: [
      { user: 'Alex M.', rating: 5, comment: 'Gripping thriller from start to finish.' },
      { user: 'Nina P.', rating: 3, comment: 'Good mystery but slow paced at times.' },
    ],
  },
  {
    id: 10,
    title: 'And Then There Were None',
    author: 'Agatha Christie',
    cover: '/assets/book-covers/and-then-there-were-none.png',
    price: 10.99,
    rating: 4.6,
    description: 'Ten strangers are invited to an island, where they are killed off one by one.',
    publisher: 'Collins Crime Club',
    year: 1939,
    isbn: '9780062073488',
    pages: 272,
    genre: 'Mystery',
    formats: [
      { type: 'Paperback', price: 10.99 },
      { type: 'Hardcover', price: 16.99 },
      { type: 'E-book', price: 7.99 },
    ],
    reviews: [
      { user: 'Oliver T.', rating: 5, comment: "Christie's masterpiece!" },
      { user: 'Emma R.', rating: 4, comment: 'Classic whodunit at its finest.' },
    ],
  },
  // History books
  {
    id: 11,
    title: 'SPQR: A History of Ancient Rome',
    author: 'Mary Beard',
    cover: '/assets/book-covers/spqr.png',
    price: 18.99,
    rating: 4.4,
    description: 'A sweeping, revisionist history of the Roman Empire from one of our foremost classicists.',
    publisher: 'Liveright',
    year: 2015,
    isbn: '9780871404237',
    pages: 608,
    genre: 'History',
    formats: [
      { type: 'Paperback', price: 18.99 },
      { type: 'Hardcover', price: 28.99 },
      { type: 'E-book', price: 14.99 },
    ],
    reviews: [
      { user: 'William H.', rating: 5, comment: 'Fascinating look at ancient Rome.' },
      { user: 'Victoria S.', rating: 4, comment: 'Well researched and engaging.' },
    ],
  },
  {
    id: 12,
    title: 'The Guns of August',
    author: 'Barbara W. Tuchman',
    cover: '/assets/book-covers/guns-of-august.png',
    price: 16.99,
    rating: 4.5,
    description: 'A dramatic account of the first month of World War I.',
    publisher: 'Macmillan',
    year: 1962,
    isbn: '9780345476098',
    pages: 511,
    genre: 'History',
    formats: [
      { type: 'Paperback', price: 16.99 },
      { type: 'Hardcover', price: 24.99 },
      { type: 'E-book', price: 12.99 },
    ],
    reviews: [
      { user: 'George K.', rating: 5, comment: 'Essential WWI history.' },
      { user: 'Helen M.', rating: 4, comment: 'Gripping historical narrative.' },
    ],
  },
  // Self-Help books
  {
    id: 13,
    title: 'Atomic Habits',
    author: 'James Clear',
    cover: '/assets/book-covers/atomic-habits.png',
    price: 16.99,
    rating: 4.7,
    description: 'An easy and proven way to build good habits and break bad ones.',
    publisher: 'Avery',
    year: 2018,
    isbn: '9780735211292',
    pages: 320,
    genre: 'Self-Help',
    formats: [
      { type: 'Paperback', price: 16.99 },
      { type: 'Hardcover', price: 24.99 },
      { type: 'E-book', price: 13.99 },
    ],
    reviews: [
      { user: 'Rachel B.', rating: 5, comment: 'Life-changing book!' },
      { user: 'Daniel W.', rating: 4, comment: 'Practical and actionable advice.' },
    ],
  },
  {
    id: 14,
    title: 'The 7 Habits of Highly Effective People',
    author: 'Stephen R. Covey',
    cover: '/assets/book-covers/7-habits.png',
    price: 15.99,
    rating: 4.6,
    description: 'Powerful lessons in personal change for achieving success.',
    publisher: 'Free Press',
    year: 1989,
    isbn: '9781982137274',
    pages: 381,
    genre: 'Self-Help',
    formats: [
      { type: 'Paperback', price: 15.99 },
      { type: 'Hardcover', price: 22.99 },
      { type: 'E-book', price: 11.99 },
    ],
    reviews: [
      { user: 'Kevin L.', rating: 5, comment: 'Timeless wisdom for success.' },
      { user: 'Michelle F.', rating: 4, comment: 'Great framework for personal development.' },
    ],
  },
  // Children's books
  {
    id: 15,
    title: "Harry Potter and the Sorcerer's Stone",
    author: 'J.K. Rowling',
    cover: '/assets/book-covers/harry-potter.png',
    price: 12.99,
    rating: 4.9,
    description: 'An orphaned boy enrolls in a school of wizardry and learns about his magical heritage.',
    publisher: 'Scholastic',
    year: 1997,
    isbn: '9780439708180',
    pages: 309,
    genre: 'Children',
    formats: [
      { type: 'Paperback', price: 12.99 },
      { type: 'Hardcover', price: 19.99 },
      { type: 'E-book', price: 8.99 },
    ],
    reviews: [
      { user: 'Sophie C.', rating: 5, comment: 'Magical start to an incredible series!' },
      { user: 'Lucas D.', rating: 5, comment: 'Perfect for readers of all ages.' },
    ],
  },
  {
    id: 16,
    title: "Charlotte's Web",
    author: 'E.B. White',
    cover: '/assets/book-covers/charlottes-web.png',
    price: 8.99,
    rating: 4.8,
    description: 'The story of a pig named Wilbur and his friendship with a barn spider named Charlotte.',
    publisher: 'Harper & Brothers',
    year: 1952,
    isbn: '9780064400558',
    pages: 192,
    genre: 'Children',
    formats: [
      { type: 'Paperback', price: 8.99 },
      { type: 'Hardcover', price: 14.99 },
      { type: 'E-book', price: 5.99 },
    ],
    reviews: [
      { user: 'Amanda N.', rating: 5, comment: 'A beautiful tale of friendship.' },
      { user: 'Brian O.', rating: 5, comment: "Classic children's literature." },
    ],
  },
  // Low-rated books
  {
    id: 17,
    title: 'The Mysterious Case',
    author: 'Unknown Writer',
    cover: '/assets/book-covers/mysterious-case.png',
    price: 7.99,
    rating: 2.3,
    description: 'A detective tries to solve a confusing mystery that nobody cares about.',
    publisher: 'Generic Press',
    year: 2020,
    isbn: '9781234567890',
    pages: 245,
    genre: 'Mystery',
    formats: [
      { type: 'Paperback', price: 7.99 },
      { type: 'E-book', price: 3.99 },
    ],
    reviews: [
      { user: 'Tom S.', rating: 2, comment: 'Confusing plot and weak characters.' },
      { user: 'Jane D.', rating: 3, comment: 'Had potential but poorly executed.' },
    ],
  },
  {
    id: 18,
    title: 'Space Adventure Gone Wrong',
    author: 'B. Writer',
    cover: '/assets/book-covers/space-adventure.png',
    price: 9.99,
    rating: 2.8,
    description: 'Astronauts face challenges in space but the story lacks depth.',
    publisher: 'Sci-Fi Books Inc',
    year: 2019,
    isbn: '9780987654321',
    pages: 312,
    genre: 'Science Fiction',
    formats: [
      { type: 'Paperback', price: 9.99 },
      { type: 'E-book', price: 5.99 },
    ],
    reviews: [
      { user: 'Chris R.', rating: 3, comment: 'Interesting premise but disappointing execution.' },
      { user: 'Paula M.', rating: 2, comment: 'Expected more from a space adventure.' },
    ],
  },
  {
    id: 19,
    title: 'Boring Romance',
    author: 'Jane Novelist',
    cover: '/assets/book-covers/boring-romance.png',
    price: 6.99,
    rating: 2.1,
    description: 'A predictable love story with cardboard characters.',
    publisher: 'Romance Publishing',
    year: 2021,
    isbn: '9781122334455',
    pages: 198,
    genre: 'Romance',
    formats: [
      { type: 'Paperback', price: 6.99 },
      { type: 'E-book', price: 2.99 },
    ],
    reviews: [
      { user: 'Lisa W.', rating: 2, comment: 'Too predictable and cliché.' },
      { user: 'Mike B.', rating: 2, comment: 'Lacks emotional depth.' },
    ],
  },
  {
    id: 20,
    title: 'Failed Self-Improvement',
    author: 'Guru McFake',
    cover: '/assets/book-covers/failed-self-help.png',
    price: 12.99,
    rating: 1.9,
    description: 'Empty platitudes disguised as life advice.',
    publisher: 'Self-Help Ltd',
    year: 2022,
    isbn: '9785544332211',
    pages: 156,
    genre: 'Self-Help',
    formats: [
      { type: 'Paperback', price: 12.99 },
      { type: 'E-book', price: 7.99 },
    ],
    reviews: [
      { user: 'Karen T.', rating: 2, comment: 'Nothing new or useful here.' },
      { user: 'Steve A.', rating: 1, comment: 'Complete waste of time and money.' },
    ],
  },
  {
    id: 21,
    title: 'The Mediocre Thriller',
    author: 'Average Author',
    cover: '/assets/book-covers/mediocre-thriller.png',
    price: 10.99,
    rating: 3.2,
    description: 'A thriller that promises excitement but delivers mediocrity.',
    publisher: 'Thriller House',
    year: 2021,
    isbn: '9786677889900',
    pages: 289,
    genre: 'Thriller',
    formats: [
      { type: 'Paperback', price: 10.99 },
      { type: 'E-book', price: 6.99 },
    ],
    reviews: [
      { user: 'Nancy P.', rating: 3, comment: 'Not bad but not great either.' },
      { user: 'Derek H.', rating: 3, comment: 'Okay for a lazy afternoon read.' },
    ],
  },
  {
    id: 22,
    title: 'Uninspired Fantasy Quest',
    author: 'Generic Fantasist',
    cover: '/assets/book-covers/uninspired-fantasy.png',
    price: 11.99,
    rating: 2.7,
    description: "Heroes go on a quest. You've read this story a hundred times before.",
    publisher: 'Fantasy World Press',
    year: 2020,
    isbn: '9783344556677',
    pages: 402,
    genre: 'Fantasy',
    formats: [
      { type: 'Paperback', price: 11.99 },
      { type: 'Hardcover', price: 18.99 },
      { type: 'E-book', price: 7.99 },
    ],
    reviews: [
      { user: 'Ryan C.', rating: 3, comment: 'Every fantasy trope you can imagine.' },
      { user: 'Melissa K.', rating: 2, comment: 'Derivative and uninspired.' },
    ],
  },
];

export const getBookById = id => {
  return books.find(book => book.id === parseInt(id, 10));
};

export const getBooksByGenre = genre => {
  if (!genre || genre === 'All') return books;
  return books.filter(book => book.genre === genre);
};

export const searchBooks = query => {
  const lowercaseQuery = query.toLowerCase();
  return books.filter(
    book => book.title.toLowerCase().includes(lowercaseQuery) || book.author.toLowerCase().includes(lowercaseQuery)
  );
};

export const getBooksByAuthor = author => {
  return books.filter(book => book.author.toLowerCase() === author.toLowerCase());
};

export const getAllAuthors = () => {
  const authorSet = new Set(books.map(book => book.author));
  return Array.from(authorSet).sort();
};

export const getAuthorNameFromSlug = slug => {
  const normalizedSlug = slug.toLowerCase();
  const author = books.find(book => book.author.toLowerCase().replace(/\s+/g, '-') === normalizedSlug)?.author;

  return author;
};
